import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type AppointmentsActionBarProps = {
   readonly children: ReactNode;
};

export const AppointmentsActionBar = (props: AppointmentsActionBarProps): JSX.Element => {
   return (
      <ActionBar id='appointments-action-bar' testId='appointments'>
         {props.children}
      </ActionBar>
   );
};
